import { useState } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@radix-ui/react-popover';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { StaticListings } from '@/types/StaticListings';
import { Button } from './ui/button';

interface BadgeSelectProps {
    options: StaticListings[];
    value: any;
    onChange: (value: any) => void;
    className?: string;
}

export default function BadgeSelect({ 
    options, 
    value, 
    onChange, 
    className 
}: BadgeSelectProps) {
    const [open, setOpen] = useState(false);
    
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div className={cn('flex items-center cursor-pointer', className)}>
                    <Badge variant="secondary" className="px-3 py-1 text-xs hover:bg-gray-200 transition-colors">
                        {value || 'Select'}
                    </Badge>
                </div>
            </PopoverTrigger>
            <PopoverContent
            side="bottom"
            align="end"
            className="w-40 p-1 rounded-lg border border-gray-200 shadow-md bg-white z-9999">
                <div className="flex flex-col">
                {
                    options.map((option) => (
                        <Button
                        key={option.value}
                        variant={'ghost'}
                        className={cn(
                            ' focus:outline-none focus-visible:outline-none focus-visible:ring-0 text-left px-3 py-2 rounded-md text-xs hover:bg-gray-100 transition-colors',
                            value === option.value ? 'bg-gray-100 font-semibold' : ''
                        )}
                        onClick={() => {
                            onChange(option.value);
                            setOpen(false);
                        }}>
                        {option.label}
                        </Button>
                    ))
                }
                </div>
            </PopoverContent>
        </Popover>
    );
}
